import * as React from 'react';
import { PropsWithChildren, useContext } from 'react';
import { CheckoutRenderers as CheckoutAdditionalRenderers } from './Checkout/components/Checkout/renderers';
import { ExchangeSearchRenderers } from './Modules/Exchange/components/Exchange/SearchFlights/renderers';
import { ExchangeRenderers } from './Modules/Exchange/renderers';
import { PassengersToolbarLabelRenderers } from './Checkout/components/Checkout/Form/PassengersToolbar/renderers';
import { RequestFormRenderers } from './Refund/Components/RequestForm/renderers';
import { FullscreenDialogRenderers } from './FullscreenDialog/components/renderers';
import { ConfirmOptionRenderers } from './ConfirmOption/renderers';
import { MetasearchLoaderRenderers } from './MetasearchLoader/renderers';
import { SearchFormDatePickerRenderers } from './SearchFormDatepicker/renderers';
import { DesktopFlightRenderers } from './DesktopFlightRoute/renderers';
import { FlightRenderers } from './MobileFlight/components/renderers';
import { DesktopFlightModalRenderers } from './DesktopFlight/components/DesktopFlightModalContent/renderers';
import { FlightInfoRenderers } from './FlightInfo/renderers';
import { CompareFaresRenderers } from './CompareFares/components/renderers';
import { SearchFormDatepickerRenderers } from './SearchFormDatepicker/components/renderers';
import { FlightCardRenderers } from './FlightCard/components/renderers';
import { SelectSegmentRenderers } from './DesktopFlightRoute/components/SelectSegment/renderers';
import { ContactsRenderers } from './Contacts/components/renderers';
import { SegmentPlaneInfoRenderers } from './DesktopFlightRoute/components/Segment/renderers';
import { DatepickerValueRenderers } from './SearchForm/components/SearchForm/Segments/Segment/Datepicker/Value/renderers';
import { PromoCodeRenderers } from './PromoCode/renderers';
import { DesktopSummaryFlightRenderers } from './DesktopSummaryFlight/renderers';
import { CheckoutRenderers } from './Checkout/renderers';
import { OrderCardRenderers } from './OrderCard/renderers';
import { ResultRenderers } from './Results/renderers';
import { BaggageIcon } from './Baggage/Baggage/renderers';
import { FareGroupV2Renderers } from '@entities/fare';
import { RetrieveBookingRenderers } from './RetrieveBooking/renderers';
import { CheckoutAdditionalServiceRenderers } from './CheckoutAdditionalService/renderers';
import { CheckinRenderers } from './Modules/Checkin/components/Checkin/Initial/renderers';
import { BaggageRenderers } from './Baggage/renderers';
import { SearchFormRenderers } from './SearchForm/renderers';
import { SearchFormRenderers as SearchFormRenderers2 } from './SearchForm/components/SearchForm/renderers';
import { getShowRenderersInConsole } from './cache';
import { LoyaltyRenderers } from './Loyalty/renderers';
import { Props as SeatMapServiceProps } from './SeatMap/components/SeatMapService/SeatMapService';
import { Props as SeatMapSeatProps } from './SeatMap/components/SeatMap/Seat/Seat';
import { WeekCalendarRenders } from './WeekCalendar/renderers';
import { SeatMapRenderers } from './SeatMap/renderers';
import { CheckinHintRenderers } from './Modules/Checkin/components/Checkin/Hint/renderers';
import { PaymentFormsRenderers } from './PaymentForm/components/renderers';
import { PromoLoaderRenderProps } from './PromoLoader/renderers';
import { Props as QuickSearchFormProps } from './QuickSearchForm/components/QuickSearchForm';
import { Props as FastSearchProps } from './Engine/components/FastSearch/FastSearch';
import { Props as FlightProps } from './Flight/Flight';
import { Props as StepbarProps } from './BaseComponents/Stepbar/components/Stepbar';
import type { Props as ScheduleFlightProps } from './Schedule/components/ScheduleFlight/ScheduleFlight';

import * as icons from './Icons';
import { InfoLinksLabelRenderers } from './InfoLinksLabel/renderers';
import { InsurancePopupRenderers } from './InsurancePopup/renderers';
import { MilesRecoveryRenderers } from './MilesRecovery/components/renderers';
import { MealComponentsRenderers } from './Meal/renderers';
import { PassengerFormRenderers } from './PassengerForm/components/renderers';
import { LoyaltyInfoRenderers } from './LoyaltyInfo/renderers';
import { MealServiceRenderers } from './MealService/renderers';
import { RefundSummaryRenderers } from './RefundSummary/renderers';
import { InsurancePageRenderers } from './InsurancePage/renderers';
import { UpgradeFlightClass } from './UpgradeFlightClass';
import { PriceDetailsRenderers } from './LEO/Refund/PriceDetails/renderers';
import { MobileStepbar } from './MobileStepbar/renderers';
import { PaginationRenderers } from '@shared/ui/Pagination';
import { LoginPageRenderers } from './LoginPage/renderers';
import { CommunicationsRenderers } from './Communications/renderers';
import { AccountRenderers } from './Account/renders';
import { RefundPricesRenderers } from '@entities/refund';

const merge = require('lodash.merge');

export type RenderedElement<Props = any> =
	| React.FunctionComponent<PropsWithChildren<Props>>
	| React.ComponentType<Props>;

type IconsRenderers = Partial<{ [K in keyof typeof icons]: React.FunctionComponent }>;

export interface EngineRenderers
	extends MealComponentsRenderers,
		PassengersToolbarLabelRenderers,
		CheckoutAdditionalRenderers,
		RequestFormRenderers,
		ExchangeSearchRenderers,
		DesktopFlightRenderers,
		FlightRenderers,
		DesktopFlightModalRenderers,
		FlightInfoRenderers,
		CompareFaresRenderers,
		FullscreenDialogRenderers,
		SearchFormDatepickerRenderers,
		FlightCardRenderers,
		SelectSegmentRenderers,
		ContactsRenderers,
		SegmentPlaneInfoRenderers,
		DatepickerValueRenderers,
		PromoCodeRenderers,
		DesktopSummaryFlightRenderers,
		CheckinRenderers,
		OrderCardRenderers,
		BaggageRenderers,
		CheckoutAdditionalServiceRenderers,
		CheckoutRenderers,
		OrderCardRenderers,
		FullscreenDialogRenderers,
		BaggageIcon,
		ResultRenderers,
		FareGroupV2Renderers,
		RetrieveBookingRenderers,
		MilesRecoveryRenderers,
		CheckoutAdditionalServiceRenderers,
		LoyaltyRenderers,
		ConfirmOptionRenderers,
		MetasearchLoaderRenderers,
		IconsRenderers,
		SeatMapRenderers,
		WeekCalendarRenders,
		CheckinHintRenderers,
		SearchFormDatePickerRenderers,
		PaymentFormsRenderers,
		InfoLinksLabelRenderers,
		SearchFormRenderers2,
		InsurancePopupRenderers,
		PromoLoaderRenderProps,
		PassengerFormRenderers,
		ExchangeRenderers,
		MealServiceRenderers,
		RefundSummaryRenderers,
		LoyaltyInfoRenderers,
		PriceDetailsRenderers,
		MobileStepbar,
		PaginationRenderers,
		RefundPricesRenderers,
		InsurancePageRenderers,
		LoginPageRenderers,
		CommunicationsRenderers,
		AccountRenderers {
	SearchForm?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	SearchFormWithStore?: SearchFormRenderers2['SearchFormComponent'];
	SearchFormPassengersCloseBtn?: React.FunctionComponentFactory<{ close: React.DispatchWithoutAction }>;
	ResultsFlightListFlight?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	ResultsChildWithoutAdultNoticeIcon?: React.FC;
	CheckoutContacts?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	SearchFormRenderers?: SearchFormRenderers;
	SeatMapService?: React.FC<SeatMapServiceProps>;
	SeatMapSeat?: React.FC<SeatMapSeatProps>;
	QuickSearchForm?: React.FC<QuickSearchFormProps>;
	FastSearch?: React.FC<FastSearchProps>;
	ScheduleForm?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	ScheduleFlight?: React.FC<ScheduleFlightProps>;
	LoginInput?: React.FC<PropsWithChildren<any>> | React.ComponentType<any>;
	CheckoutInsurances?: React.FC<PropsWithChildren<any>> | React.ComponentType<any>;
	SeatMapPassengers?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	SearchFormSegmentValue?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	ExchangeFlight?: React.FC<FlightProps>;
	FareGroup?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	CheckoutPaymentForm?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	ExchangePaymentForm?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	LoyaltySummaryV2?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	ScheduleLocations?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	TravellerForm?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	CheckoutServices?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	CheckinServices?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	CheckinPaymentResult?: React.FunctionComponent<PropsWithChildren<any>> | React.ComponentType<any>;
	CheckinUpgradeFlightClass?: typeof UpgradeFlightClass;
	Stepbar?: React.FC<StepbarProps>;
}

const RenderersContext = React.createContext<EngineRenderers>({});

export const RenderersProvider: React.FC<{ value: EngineRenderers }> = React.memo(({ value, children }) => {
	const currentRenderers: EngineRenderers = useContext(RenderersContext);

	return <RenderersContext.Provider value={merge(currentRenderers, value)}>{children}</RenderersContext.Provider>;
});

export const { Consumer: RenderersConsumer } = RenderersContext;
export { RenderersContext };

export const useRenderers = <M extends keyof EngineRenderers>(): EngineRenderers => useContext(RenderersContext);
export const NULL_COMPONENT: React.FC = () => null;

interface Props<T> {
	componentProps: T & { key?: React.Key };
	component: Partial<EngineRenderers>;
}

/**
 * @deprecated
 */
export const OverrideComponent = <T extends {}>(props: PropsWithChildren<Props<T>>): React.ReactElement => {
	/**
	  Use {@link useRenderers} instead.
	  @example <caption>Pattern</caption>
	  const { ComponentName: ComponentNameOverride = ComponentName } = useRenderers();
	  @example <caption>Real usage</caption>
	  const { FirstLoginAgreement: FirstLoginAgreementOverride = FirstLoginAgreementBase } = useRenderers();
	 */

	const rerenders = useContext(RenderersContext);
	const componentName = Object.keys(props.component)[0];

	if (rerenders.hasOwnProperty(componentName) && rerenders[componentName]) {
		const Component = rerenders[componentName];

		if (getShowRenderersInConsole()) {
			console.log(`%c Override component ${componentName} `, 'background: #222; color: #bada55; font-size: 16px');
		}

		return <Component {...props.componentProps} />;
	}

	const Component = props.component[componentName];

	return <Component {...props.componentProps} />;
};
